import { render, staticRenderFns } from "./EditSize.vue?vue&type=template&id=5a51070a&scoped=true&"
import script from "./EditSize.vue?vue&type=script&lang=js&"
export * from "./EditSize.vue?vue&type=script&lang=js&"
import style0 from "./EditSize.vue?vue&type=style&index=0&id=5a51070a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51070a",
  null
  
)

export default component.exports